import * as am5map from '@amcharts/amcharts5/map';
import worldLow from '@amcharts/amcharts5-geodata/worldLow';
import * as am5 from '@amcharts/amcharts5';

import { applyClickView } from './applyClickView';


export const applySectorScore = (
    root: any,
    mainChart: any,
    data: any,
    setPolygonSeriesHeatMap: any,
    selectedCountryPolygon: any,
    handleSelectCountry: any,
    handleHoveredCountry: any,
) => {
    // Create polygon series
    const polygonSeriesHeatMap = mainChart.series.push(
        am5map.MapPolygonSeries.new(root, {
            geoJSON: worldLow,
            valueField: "score",
            calculateAggregates: true,
        }),
    );


    applyClickView(
        polygonSeriesHeatMap,
        mainChart,
        selectedCountryPolygon,
        handleSelectCountry,
    );

    polygonSeriesHeatMap.mapPolygons.template.events.on(
        'pointerover',
        (event: any) => {
            handleHoveredCountry(event.target.dataItem.dataContext.code);
        },
    );

    polygonSeriesHeatMap.mapPolygons.template.states.create('active', {
        fill: am5.color(0xff0000),
    });

    polygonSeriesHeatMap.set('heatRules', [
        {
            target: polygonSeriesHeatMap.mapPolygons.template,
            dataField: 'value',
            key: 'fill',
            customFunction: function (sprite:any, min:any, max:any, value:any) {
                if (value < 67) {
                    sprite.set("fill", am5.color(0x13B25B));
                }else if (value < 133) {
                    sprite.set("fill", am5.color(0xF9C013));
                } else {
                    sprite.set("fill", am5.color(0xF91313));
                } 
            }
        },
    ]);

    polygonSeriesHeatMap.mapPolygons.template.setAll({
        tooltipText: `[font-size: 1rem;]{name}[/]: [font-size: 1rem;]{score}[/]`,
        fill: am5.color(0xbdd6e4),
        stroke: am5.color(0x2e8bc0),
        strokeWidth: 2,
        fillOpacity: 1,
        strokeOpacity: 1,
        toggleKey: 'active',
        interactive: true,
    });

    polygonSeriesHeatMap.data.setAll(data);

    setPolygonSeriesHeatMap(polygonSeriesHeatMap);
};

export const removeSectorScore = (mainChart: any, polygonSeriesHeatMap: any) => {
    if (
        polygonSeriesHeatMap &&
        mainChart.series.indexOf(polygonSeriesHeatMap) > 0
    ) {
        mainChart.series.removeIndex(
            mainChart.series.indexOf(polygonSeriesHeatMap),
        );
    }
};
